module.exports = __webpack_public_path__ + "img/default-desktop-english.ee8ad507.png";